<template>
  <div class="mt-4 mx-3 row white-box px-3 py-4">
    <div class="white-box-top"></div>
    <div class="col-md-4 col-lg-2">
      <nav class="left-nav">
        <h4 class="mb-2">
          {{ $t("servers.webshops") }}
        </h4>
        <div class="items">
          <button
            v-for="webshop in webshops"
            :key="webshop.id"
            class="btn w-100 text-start"
            :class="[
              webshop.id === selectedWebshop?.id ? 'btn-primary' : 'btn-simple',
            ]"
            v-on:click="selectedWebshop = webshop"
          >
            {{ webshop.name }}
          </button>
          <button
            class="btn w-100 text-start"
            :class="!selectedWebshop?.id ? 'btn-primary' : 'btn-simple'"
            v-on:click="selectedWebshop = {}"
          >
            {{
              !selectedWebshop?.id && selectedWebshop?.name
                ? "+ " + selectedWebshop?.name
                : "+ new webshop"
            }}
          </button>
        </div>
        <h4 class="my-2">
          {{ $t("webshops.setting") }}
        </h4>
        <div
          class="items"
          v-scroll-spy-link="{ selector: 'a', class: 'btn-primary' }"
          v-scroll-spy-active="{ selector: 'a div', class: 'btn-primary' }"
        >
          <div class="items">
            <a href="#basics"
              ><div class="btn w-100 btn-simple text-start">
                {{ $t("warehouses.basics") }}
              </div></a
            >
            <template v-if="selectedWebshop?.id">
              <a href="#warehouses"
                ><div class="btn w-100 btn-simple text-start">
                  {{ $t("webshops.warehouses") }}
                </div></a
              >
              <a href="#delivery"
                ><div class="btn w-100 btn-simple text-start">
                  {{ $t("order.delivery2") }}
                </div></a
              >
              <a href="#payment"
                ><div class="btn w-100 btn-simple text-start">
                  {{ $t("order.payment") }}
                </div></a
              >
            </template>
          </div>
        </div>
      </nav>
    </div>
    <div
      class="col-md-8 col-lg-10"
      v-scroll-spy="{ offset: 120 }"
      v-if="selectedWebshop"
    >
      <section id="basics">
        <h2>
          {{ $t("webshops.webshopSettings") }}
        </h2>
        <h4>
          {{ $t("webshops.basics") }}
        </h4>
        <div class="row text-start custom-input whitebg-input mt-4">
          <div class="row mb-3">
            <div class="col-5 mb-3">
              <label class="form-label bold-12 text-gray">
                {{ $t("session.name") }}
              </label>
              <input
                type="text"
                class="form-control remove-padding"
                :placeholder="$t(`session.name`)"
                v-model="selectedWebshop.name"
              />
            </div>
            <div class="col-4 mb-3">
              <label class="form-label bold-12 text-gray">
                {{ $t("webshops.domain") }}
              </label>
              <input
                type="text"
                class="form-control remove-padding"
                placeholder="webshop.com"
                v-model="selectedWebshop.domain"
              />
            </div>
            <div class="col-3 mb-3">
              <label class="form-label bold-12 text-gray">{{
                $t("webshops.urlSlug")
              }}</label>
              <input
                type="text"
                class="form-control remove-padding"
                placeholder="w-hu"
                v-model="selectedWebshop.slug"
              />
            </div>
            <div class="col-3 mb-3">
              <label class="form-label bold-12 text-gray">{{
                $t("warehouses.currency")
              }}</label>
              <v-select
                v-model="selectedWebshop.currency_code"
                :options="enabledCurrencies"
                label="code"
                :placeholder="$t(`webshops.selectOne`)"
                :reduce="(o) => o.code"
                :getOptionKey="(c) => c.code"
                append-to-body
              />
            </div>
            <div class="col-6 mb-3">
              <label class="form-label bold-12 text-gray">{{
                $t("warehouses.company")
              }}</label>
              <v-select
                v-model="selectedWebshop.company_id"
                :options="companies"
                label="name"
                :placeholder="$t(`webshops.selectOne`)"
                :reduce="(o) => o.id"
                append-to-body
              />
            </div>
            <div class="col-3 mb-3">
              <label class="form-label bold-12 text-gray">{{
                $t("webshops.language")
              }}</label>
              <v-select
                v-model="selectedWebshop.default_language_code"
                :options="languages"
                label="name"
                :placeholder="$t(`webshops.selectOne`)"
                :reduce="(o) => o.code"
                :getOptionKey="(c) => c.code"
                append-to-body
              />
            </div>
            <div class="col-3 mb-3">
              <label class="form-label bold-12 text-gray">{{
                $t("register.email")
              }}</label>
              <input
                type="email"
                class="form-control remove-padding"
                placeholder="info@myshop.com"
                v-model="selectedWebshop.email"
              />
            </div>
            <div class="col-3 mb-3">
              <label class="form-label bold-12 text-gray">{{
                $t("warehouses.phone")
              }}</label>
              <input
                type="tel"
                class="form-control remove-padding"
                placeholder="+101234567"
                v-model="selectedWebshop.phone"
              />
            </div>
            <div class="col-3 mb-3">
              <label class="form-label bold-12 text-gray">{{
                $t("webshops.storesInThisCountry")
              }}</label>
              <v-select
                v-model="selectedWebshop.country_id"
                :options="countries"
                label="name"
                :placeholder="$t(`webshops.selectOne`)"
                :reduce="(o) => o.id"
                append-to-body
              />
            </div>
            <div class="col-3 mb-3">
              <label class="form-label bold-12 text-gray">
                Allow return duration
              </label>
              <div class="fix-end-input">
                <input
                  type="number"
                  class="form-control"
                  v-model="selectedWebshop.return_allowed_days"
                  step="1"
                  :min="1"
                  :disabled="!selectedWebshop.is_return"
                />
                <span>days</span>
              </div>
            </div>
            <div class="col-12 mb-3">
              <label class="cstm-check d-flex" for="ct-1">
                <span class="regular-12 text-black mt-3">
                  Product return service
                </span>
                <input
                  type="checkbox"
                  v-model="selectedWebshop.is_return"
                  value="1"
                  id="ct-1"
                />
                <span class="checkmark mt-3"></span>
              </label>
            </div>
            <div class="col-12 mb-3">
              <label class="cstm-check d-flex" for="ct-2">
                <span class="regular-12 text-black mt-3">
                  Product change service
                </span>
                <input
                  type="checkbox"
                  v-model="selectedWebshop.is_change"
                  value="1"
                  id="ct-2"
                />
                <span class="checkmark mt-3"></span>
              </label>
            </div>
            <div class="col-12 mb-3">
              <label class="cstm-check d-flex" for="ct-3">
                <span class="regular-12 text-black mt-3">
                  International COD service
                </span>
                <input
                  type="checkbox"
                  v-model="selectedWebshop.is_international_cod"
                  value="1"
                  id="ct-3"
                />
                <span class="checkmark mt-3"></span>
              </label>
            </div>
            <div class="col-12 mb-3">
              <label class="cstm-check d-flex" for="ct-6">
                <span class="regular-12 text-black mt-3">
                  Use default language
                </span>
                <input
                  type="checkbox"
                  v-model="selectedWebshop.use_default_language"
                  value="1"
                  id="ct-6"
                />
                <span class="checkmark mt-3"></span>
              </label>
            </div>
            <div class="col-12 mb-3">
              <label class="cstm-check d-flex" for="ct-4">
                <span class="regular-12 text-black mt-3">
                  Group delivery methods
                </span>
                <input
                  type="checkbox"
                  v-model="selectedWebshop.is_group_delivery_methods"
                  value="1"
                  id="ct-4"
                />
                <span class="checkmark mt-3"></span>
              </label>
            </div>
          </div>
        </div>
        <div class="row mb-3 d-grid justify-content-end me-4">
          <button
            type="submit"
            class="btn btn-type-2 btn-normal"
            :disabled="basicSaving"
            v-on:click="saveBasic"
          >
            <span>{{ $t("orderChange.save") }}</span>
          </button>
        </div>
        <hr class="my-4" />
      </section>
      <section id="warehouses" v-if="selectedWebshop?.id">
        <h4>{{ $t("webshops.warehouses") }}</h4>
        <div class="row">
          <div class="col-6">
            <h5>Delivery</h5>
            <draggable
              class="dragArea row custom-input pt-2"
              tag="ul"
              :list="selectedWebshop.deliveryWarehouses"
              :group="{ name: 'g1' }"
              item-key="id"
              v-bind="dragOptions"
              :forceFallback="true"
              :scroll="true"
              :scrollSensitivity="100"
            >
              <template #item="{ element, index }">
                <li class="row">
                  <div class="col-3">{{ ordinal_suffix_of(index) }}</div>
                  <div class="col">{{ element.name }}</div>
                  <div class="col-auto">
                    <button
                      class="btn btn-transparent"
                      v-on:click="deleteWarehouse('delivery', element.id)"
                    >
                      <BaseIcon name="trash" />
                    </button>
                  </div>
                </li>
              </template>
            </draggable>
            <div class="row align-items-end">
              <div class="col">
                <label class="form-label bold-12 text-gray">{{
                  $t("webshops.warehouse")
                }}</label>
                <v-select
                  v-model="selectedDeliveryWebshop"
                  :options="deliveryWarehouseOptions"
                  label="name"
                  :placeholder="$t(`webshops.selectOne`)"
                  append-to-body
                />
              </div>
              <div class="col-auto">
                <button
                  class="btn btn-transparent"
                  v-on:click="addWarehouse('delivery')"
                >
                  <BaseIcon name="add" />
                </button>
              </div>
            </div>
          </div>
          <div class="col-6">
            <h5>Return</h5>
            <draggable
              class="dragArea row custom-input pt-2"
              tag="ul"
              :list="selectedWebshop.returnWarehouses"
              :group="{ name: 'g1' }"
              item-key="id"
              v-bind="dragOptions"
              :forceFallback="true"
              :scroll="true"
              :scrollSensitivity="100"
            >
              <template #item="{ element, index }">
                <li class="row">
                  <div class="col-3">{{ ordinal_suffix_of(index) }}</div>
                  <div class="col">{{ element.name }}</div>
                  <div class="col-auto">
                    <button
                      class="btn btn-transparent"
                      v-on:click="deleteWarehouse('return', element.id)"
                    >
                      <BaseIcon name="trash" />
                    </button>
                  </div>
                </li>
              </template>
            </draggable>
            <div class="row align-items-end">
              <div class="col">
                <label class="form-label bold-12 text-gray">{{
                  $t("webshops.warehouse")
                }}</label>
                <v-select
                  v-model="selectedReturnWebshop"
                  :options="returnWarehouseOptions"
                  label="name"
                  :placeholder="$t(`webshops.selectOne`)"
                  append-to-body
                />
              </div>
              <div class="col-auto">
                <button
                  class="btn btn-transparent"
                  v-on:click="addWarehouse('return')"
                >
                  <BaseIcon name="add" />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-3 d-grid justify-content-end me-4">
          <button
            type="submit"
            class="btn btn-type-2 btn-normal"
            v-on:click="saveWarehouses"
          >
            <span>{{ $t("orderChange.save") }}</span>
          </button>
        </div>
        <hr class="my-4" />
      </section>

      <section id="delivery" class="mb-5" v-if="selectedWebshop?.id">
        <div class="row align-items-center mb-2">
          <div class="col">
            <h4>{{ $t("order.delivery2") }}</h4>
          </div>
          <div class="col-auto">
            <button
              type="button"
              class="btn btn-no-r"
              :class="
                deliveryGrouping === 'method' ? 'btn-primary' : 'btn-secondary'
              "
              v-on:click="deliveryGrouping = 'method'"
            >
              <span>{{ $t("webshops.groupByMethod") }}</span>
            </button>
            <button
              type="button"
              class="btn btn-no-l"
              :class="
                deliveryGrouping === 'country' ? 'btn-primary' : 'btn-secondary'
              "
              v-on:click="deliveryGrouping = 'country'"
            >
              <span>{{ $t("webshops.groupByCountry") }}</span>
            </button>
          </div>
        </div>

        <template v-if="deliveryGrouping === 'method'">
          <div class="row align-items-center mb-1">
            <div class="col">
              <button
                v-for="(method, i) in deliveryMethodTabs"
                :key="method.id"
                type="button"
                class="btn btn-small tab-removable btn-main-method-list"
                :class="[
                  method.id == selectedDeliveryMethodId
                    ? 'btn-primary'
                    : 'btn-secondary',
                  i > 0 ? 'btn-no-l' : '',
                  i < deliveryMethodTabs.length - 1 ? 'btn-no-r' : '',
                ]"
                v-on:click="selectedDeliveryMethodId = method.id"
              >
                <span>{{ method.name }}</span>
                <BaseIcon
                  name="close-circle"
                  class="remove-x"
                  v-on:click.stop="disableDeliveryMethod(method)"
                />
              </button>
              <button
                v-if="deliveryMethodOptions.length > 0"
                type="button"
                class="btn btn-type-2 btn-small"
                :class="deliveryAdder === 'method' ? 'btn-primary' : ''"
                v-on:click="
                  deliveryAdder = deliveryAdder === 'method' ? null : 'method'
                "
              >
                <BaseIcon name="add" class="height-1rem" />
              </button>
              <v-select
                v-if="
                  deliveryAdder === 'method' && deliveryMethodOptions.length > 0
                "
                v-model="deliveryMethodToAdd"
                :options="deliveryMethodOptions"
                label="name"
                :reduce="(m) => m.id"
                :placeholder="$t(`webshops.addDeliveryMethod`)"
                :clearable="false"
                append-to-body
                class="delivery-add-select"
              />
            </div>
          </div>
          <div
            class="row align-items-center mb-3"
            v-if="selectedDeliveryMethod"
          >
            <div class="col">
              <span
                v-for="country in selectedDeliveryMethodCountries"
                :key="country.id"
                class="badge info me-1 mb-1 removable-badge"
              >
                {{ country.name }}
                <BaseIcon
                  name="close-circle"
                  class="remove-x"
                  role="button"
                  v-on:click="
                    removeDeliveryCountry(selectedDeliveryMethod, country.id)
                  "
                />
              </span>
              <button
                v-if="deliveryCountryOptions.length > 0"
                type="button"
                class="btn btn-type-2 btn-small me-1 mb-1"
                :class="deliveryAdder === 'country' ? 'btn-primary' : ''"
                v-on:click="
                  deliveryAdder = deliveryAdder === 'country' ? null : 'country'
                "
              >
                <BaseIcon name="add" class="height-1rem" />
              </button>
              <v-select
                v-if="
                  deliveryAdder === 'country' &&
                  deliveryCountryOptions.length > 0
                "
                v-model="deliveryCountryToAdd"
                :options="deliveryCountryOptions"
                label="name"
                :reduce="(c) => c.id"
                :placeholder="$t(`webshops.addDeliveryCountry`)"
                :clearable="false"
                append-to-body
                class="delivery-add-select"
              />
            </div>
          </div>
        </template>

        <template v-else>
          <div class="row align-items-center mb-1">
            <div class="col">
              <button
                v-for="(country, i) in deliveryCountryTabList"
                :key="country.id"
                type="button"
                class="btn btn-small tab-removable btn-main-method-list"
                :class="[
                  country.id == selectedDeliveryCountryId
                    ? 'btn-primary'
                    : 'btn-secondary',
                  i > 0 ? 'btn-no-l' : '',
                  i < deliveryCountryTabList.length - 1 ? 'btn-no-r' : '',
                ]"
                v-on:click="selectedDeliveryCountryId = country.id"
              >
                <span>{{ country.name }}</span>
                <BaseIcon
                  name="close-circle"
                  class="remove-x"
                  v-on:click.stop="disableDeliveryCountry(country.id)"
                />
              </button>
              <button
                v-if="deliveryNewCountryOptions.length > 0"
                type="button"
                class="btn btn-type-2 btn-small me-1 mb-1"
                :class="deliveryAdder === 'newCountry' ? 'btn-primary' : ''"
                v-on:click="
                  deliveryAdder =
                    deliveryAdder === 'newCountry' ? null : 'newCountry'
                "
              >
                <BaseIcon name="add" class="height-1rem" />
              </button>
              <v-select
                v-if="
                  deliveryAdder === 'newCountry' &&
                  deliveryNewCountryOptions.length > 0
                "
                v-model="deliveryNewCountryToAdd"
                :options="deliveryNewCountryOptions"
                label="name"
                :reduce="(c) => c.id"
                :placeholder="$t(`webshops.addDeliveryCountry`)"
                :clearable="false"
                append-to-body
                class="delivery-add-select"
              />
            </div>
          </div>
          <div
            class="row align-items-center mb-3"
            v-if="selectedDeliveryCountryId"
          >
            <div class="col">
              <span
                v-for="method in selectedDeliveryCountryMethods"
                :key="method.id"
                class="badge info me-1 mb-1 removable-badge"
              >
                {{ method.name }}
                <BaseIcon
                  name="close-circle"
                  class="remove-x"
                  role="button"
                  v-on:click="
                    removeDeliveryCountry(method, selectedDeliveryCountryId)
                  "
                />
              </span>
              <button
                v-if="deliveryMethodForCountryOptions.length > 0"
                type="button"
                class="btn btn-type-2 btn-small me-1 mb-1"
                :class="
                  deliveryAdder === 'methodForCountry' ? 'btn-primary' : ''
                "
                v-on:click="
                  deliveryAdder =
                    deliveryAdder === 'methodForCountry'
                      ? null
                      : 'methodForCountry'
                "
              >
                <BaseIcon name="add" class="height-1rem" />
              </button>
              <v-select
                v-if="
                  deliveryAdder === 'methodForCountry' &&
                  deliveryMethodForCountryOptions.length > 0
                "
                v-model="deliveryMethodForCountryToAdd"
                :options="deliveryMethodForCountryOptions"
                label="name"
                :reduce="(m) => m.id"
                :placeholder="$t(`webshops.addDeliveryMethod`)"
                :clearable="false"
                append-to-body
                class="delivery-add-select"
              />
            </div>
          </div>
        </template>

        <div
          v-for="section in deliveryLeafSections"
          :key="section.key"
          class="mb-3"
        >
          <div class="row align-items-center mb-1">
            <div class="col">
              <img
                v-if="section.logo"
                :src="section.logo"
                class="height-1rem me-2"
                alt=""
              />
              <b class="me-1">{{ section.label }}</b>
              <span class="badge info me-2" v-if="section.isAutomaticSelect">
                Auto select
              </span>
              <span class="regular-12 text-gray" v-if="section.typeName">
                {{ section.typeName }}
              </span>
            </div>
            <div class="col-auto">
              <template v-if="sectionApps(section).length > 0">
                <span class="regular-12 text-gray me-1">Provider:</span>
                <v-select
                  :model-value="sectionAppId(section)"
                  :options="sectionApps(section)"
                  label="name"
                  :reduce="(a) => a.id"
                  :clearable="false"
                  :placeholder="$t(`webshops.selectOne`)"
                  append-to-body
                  class="section-provider-select"
                  v-on:update:modelValue="
                    (appId) => setSectionProvider(section, appId)
                  "
                >
                  <template #selected-option="{ name, icon }">
                    <img
                      v-if="icon"
                      :src="methodLogoUrl(icon)"
                      class="height-1rem me-1"
                      alt=""
                    />
                    <span>{{ name }}</span>
                  </template>
                  <template #option="{ name, icon }">
                    <img
                      v-if="icon"
                      :src="methodLogoUrl(icon)"
                      class="height-1rem me-1"
                      alt=""
                    />
                    <span>{{ name }}</span>
                  </template>
                </v-select>
              </template>
              <label
                v-if="section.canAutoSelect"
                class="
                  cstm-check
                  d-flex
                  align-items-center
                  ms-3
                  auto-select-check
                "
                :for="'auto-select-' + section.key"
              >
                <input
                  type="checkbox"
                  :id="'auto-select-' + section.key"
                  :checked="sectionAutoSelect(section)"
                  v-on:change="toggleSectionAutoSelect(section)"
                />
                <span class="checkmark"></span>
                <span class="regular-12 text-black ms-1">
                  Allow auto select
                </span>
              </label>
            </div>
          </div>
          <OneByOneTable
            v-if="currencies.length > 0"
            :rows="sectionRows(section)"
            v-model:items="section.items"
            type="delivery"
            :empty-line="true"
            :show-add="false"
            :key="section.key + '-' + key"
            v-on:delete="(d) => deleteDeliveryPrice(d)"
            v-on:update:field="(d, e, f) => updateDeliveryPrice(d, e, f)"
            v-on:add:field="(e, f) => addDeliveryPrice(section, e, f)"
            :disabled="disabled"
            :noMinHeight="true"
          />
        </div>
      </section>
      <section id="payment" v-if="selectedWebshop?.id">
        <h4>{{ $t("order.payment") }}</h4>
        <OneByOneTable
          v-model:rows="paymentRows"
          v-model:items="payment"
          :show-add="false"
          :show-del="false"
          type="payment"
        />
        <div class="row mb-3 d-grid justify-content-end me-4">
          <button
            type="submit"
            class="btn btn-type-2 btn-normal"
            v-on:click="savePayment"
          >
            <span>{{ $t("orderChange.save") }}</span>
          </button>
        </div>
        <hr class="my-4" />

        <h5>{{ $t("webshops.paymentPrices") }}</h5>
        <div v-for="group in paymentGroups" :key="group.key" class="mb-3">
          <b>{{ group.label }}</b>
          <OneByOneTable
            v-if="currencies.length > 0 && payments.length > 0"
            :rows="paymentPriceRowsView"
            v-model:items="group.items"
            type="payment"
            :empty-line="true"
            :show-add="false"
            :key="group.key + '-' + key"
            v-on:delete="(d) => deletePaymentPrice(d)"
            v-on:update:field="(d, e, f) => updatePaymentPrice(d, e, f)"
            v-on:add:field="(e, f) => addPaymentPrice(group, e, f)"
          />
        </div>
      </section>
      <ConfirmModal
        ref="deleteModal"
        :title="$t(`webshops.deletePriceTitle`)"
        :text="`<ul><li>You will delete a price of this sale channel<b></li><li>You can't undo this action</li></ul><p>Are you sure you want to delete?</p>`"
        cancel-button="No, keep the price"
        ok-button="Yes, delete the price"
        v-on:success="deletePrice"
      />
    </div>
  </div>
</template>

<script>
import OneByOneTable from "../lists/OneByOneTable";
import http from "@/modules/http";
import tenant from "@/modules/tenant";
import { useStore } from "vuex";
import draggable from "vuedraggable";
import BaseIcon from "../icons/BaseIcon.vue";
import ConfirmModal from "@/components/modals/ConfirmModal";

const deliveryTypeValues = {
  1: { id: 1, name: "Normal delivery" },
  2: { id: 2, name: "Pick-up point" },
  3: { id: 3, name: "Return" },
  4: { id: 4, name: "Change" },
  5: { id: 5, name: "Next day delivery" },
  6: { id: 6, name: "Saturday delivery" },
  7: { id: 7, name: "Flexible day delivery" },
  8: { id: 8, name: "Timeslot delivery" },
  9: { id: 9, name: "Drop off return" },
};

const globalPaymentTypes = [3, 4, 5];

export default {
  name: "webshops",
  components: { BaseIcon, OneByOneTable, draggable, ConfirmModal },
  data() {
    return {
      store: useStore(),
      webshops: [],
      companies: [],
      selectedWebshop: undefined,
      key: 0,
      disabled: false,
      basicSaving: false,
      deliveryGrouping: "method",
      selectedDeliveryMethodId: null,
      selectedDeliveryCountryId: null,
      deliveryMethodToAdd: null,
      deliveryCountryToAdd: null,
      deliveryNewCountryToAdd: null,
      deliveryMethodForCountryToAdd: null,
      deliveryAdder: null,
      deliverySaving: false,
      deliverySaveQueued: false,
      deliveryPrices: [],
      paymentPrices: [],
      deleteItem: null,
      deleteType: null,
      paymentRows: [
        {
          name: "Name",
          key: "name",
          type: "string",
          editable: false,
          show: true,
        },
        {
          name: "Provider",
          key: "app_name",
          type: "string",
          editable: false,
          show: true,
        },
        {
          name: "Type",
          key: "type",
          type: "enum",
          label: "name",
          values: {
            1: { id: 1, name: "Prepaid" },
            2: { id: 2, name: "Payment on delivery" },
            3: { id: 3, name: "Cash" },
            4: { id: 4, name: "Bank transfer" },
            5: { id: 5, name: "Card on shop" },
          },
          editable: false,
          show: true,
        },
        {
          name: "Active",
          key: "active",
          type: "boolean",
          show: true,
        },
      ],
      payment: [],
      payments: [],
      deliveries: [],
      delivery: [],
      deliveryApps: {},
      deliveryPriceRows: [
        {
          name: "Currency",
          key: "currency_code",
          type: "enum",
          values: [],
          label: "code",
          selectKey: "code",
          show: true,
        },
        {
          name: "Price",
          key: "price",
          type: "number",
          show: true,
        },
        {
          name: "Min order amount",
          key: "min_order_amount",
          type: "number",
          show: true,
        },
        {
          name: "Min ordered item count",
          key: "min_order_count",
          type: "number",
          show: true,
        },
        {
          name: "Warehouse restriction",
          key: "warehouse_id",
          type: "enum",
          values: [],
          label: "name",
          selectKey: "id",
          show: true,
        },
        {
          name: "Pickup point type restriction",
          key: "delivery_point_type",
          type: "enum",
          values: [
            { id: null, name: " - " },
            { id: 1, name: "Pick-up point" },
            { id: 2, name: "Post office" },
            { id: 3, name: "Parcel automate" },
          ],
          label: "name",
          selectKey: "id",
          show: true,
        },
        {
          name: "In delivery",
          key: "is_delivery",
          type: "boolean",
          show: true,
          disabled_row: "has_delivery",
        },
        {
          name: "In return",
          key: "is_return",
          type: "boolean",
          show: true,
          disabled_row: "has_return",
        },
      ],
      paymentPriceRows: [
        {
          name: "Country",
          key: "country_id",
          type: "enum",
          label: "name",
          selectKey: "id",
          values: [],
          show: true,
        },
        {
          name: "Type",
          key: "type",
          type: "enum",
          label: "name",
          values: deliveryTypeValues,
          editable: false,
          show: false,
        },
        {
          name: "Provider",
          key: "app_id",
          type: "enum",
          label: "name",
          selectKey: "id",
          valuesKey: "delivery_method_id",
          values: {},
          show: false,
        },
        {
          name: "Currency",
          key: "currency_code",
          type: "enum",
          values: [],
          label: "code",
          selectKey: "code",
          show: true,
        },
        {
          name: "Price",
          key: "price",
          type: "number",
          show: true,
        },
        {
          name: "Min order amount",
          key: "min_order_amount",
          type: "number",
          show: true,
        },
        {
          name: "Min ordered item count",
          key: "min_order_count",
          type: "number",
          show: true,
        },
        {
          name: "Warehouse restriction",
          key: "warehouse_id",
          type: "enum",
          values: [],
          label: "name",
          selectKey: "id",
          show: true,
        },
        {
          name: "Pickup point type restriction",
          key: "delivery_point_type",
          type: "enum",
          values: [
            { id: null, name: " - " },
            { id: 1, name: "Pick-up point" },
            { id: 2, name: "Post office" },
            { id: 3, name: "Parcel automate" },
          ],
          label: "name",
          selectKey: "id",
          show: true,
        },
        {
          name: "In delivery",
          key: "is_delivery",
          type: "boolean",
          show: true,
          disabled_row: "has_delivery",
        },
        {
          name: "In return",
          key: "is_return",
          type: "boolean",
          show: true,
          disabled_row: "has_return",
        },
        {
          name: "Allow auto select",
          key: "auto_select",
          type: "boolean",
          show: true,
          disabled_row: "is_home_delivery",
        },
      ],
      selectedDeliveryWebshop: null,
      selectedReturnWebshop: null,
      dragOptions: {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      },
      columnNumbers: [
        this.$t("serialNumbers.first"),
        this.$t("serialNumbers.second"),
        this.$t("serialNumbers.third"),
        this.$t("serialNumbers.fourth"),
        this.$t("serialNumbers.fifth"),
        this.$t("serialNumbers.sixth"),
        this.$t("serialNumbers.seventh"),
        this.$t("serialNumbers.eighth"),
        this.$t("serialNumbers.ninth"),
        this.$t("serialNumbers.tenth"),
      ],
    };
  },
  computed: {
    warehouses() {
      return this.store.state.warehouses;
    },
    hasMultipleActiveWarehouses() {
      const webshop = this.selectedWebshop;
      if (!webshop) {
        return false;
      }
      const ids = [];
      for (const w of webshop.deliveryWarehouses ?? []) {
        ids.push(w.id);
      }
      for (const w of webshop.returnWarehouses ?? []) {
        if (!ids.some((id) => id == w.id)) {
          ids.push(w.id);
        }
      }
      return ids.length > 1;
    },
    deliveryWarehouseOptions() {
      const used = this.selectedWebshop?.deliveryWarehouses ?? [];
      return this.warehouses.filter((w) => !used.some((u) => u.id == w.id));
    },
    returnWarehouseOptions() {
      const used = this.selectedWebshop?.returnWarehouses ?? [];
      return this.warehouses.filter((w) => !used.some((u) => u.id == w.id));
    },
    enabledCurrencies() {
      return this.store.state.currencies;
    },
    currencies() {
      return this.store.state.currencies;
    },
    languages() {
      return this.store.state.languages;
    },
    countries() {
      return this.store.state.countries;
    },
    deliveryMethodTabs() {
      return this.delivery.filter((m) => m.active);
    },
    deliveryMethodOptions() {
      return this.delivery.filter((m) => !m.active);
    },
    selectedDeliveryMethod() {
      return (
        this.delivery.find((m) => m.id == this.selectedDeliveryMethodId) ?? null
      );
    },
    selectedDeliveryMethodCountries() {
      const active = this.selectedDeliveryMethod?.countries?.active ?? [];
      return this.countries.filter((c) => active.some((id) => id == c.id));
    },
    deliveryCountryOptions() {
      const method = this.selectedDeliveryMethod;
      if (!method) {
        return [];
      }
      const supported = method.countries?.all;
      return this.countries.filter(
        (c) =>
          !method.countries.active.some((id) => id == c.id) &&
          (!supported ||
            supported.some(
              (code) =>
                String(code).toUpperCase() === String(c.code).toUpperCase()
            ))
      );
    },
    deliveryCountryTabs() {
      const tabs = [];
      for (const method of this.delivery) {
        if (!method.active) {
          continue;
        }
        for (const countryId of method.countries?.active ?? []) {
          if (tabs.some((c) => c.id == countryId)) {
            continue;
          }
          const country = this.countries.find((c) => c.id == countryId);
          if (country) {
            tabs.push(country);
          }
        }
      }
      return tabs;
    },
    deliveryCountryTabList() {
      const tabs = [...this.deliveryCountryTabs];
      if (
        this.selectedDeliveryCountryId &&
        !tabs.some((c) => c.id == this.selectedDeliveryCountryId)
      ) {
        const pending = this.countries.find(
          (c) => c.id == this.selectedDeliveryCountryId
        );
        if (pending) {
          tabs.push(pending);
        }
      }
      return tabs;
    },
    deliveryNewCountryOptions() {
      return this.countries.filter(
        (c) => !this.deliveryCountryTabs.some((t) => t.id == c.id)
      );
    },
    selectedDeliveryCountryMethods() {
      return this.deliveryMethodTabs.filter((m) =>
        (m.countries?.active ?? []).some(
          (id) => id == this.selectedDeliveryCountryId
        )
      );
    },
    deliveryMethodForCountryOptions() {
      return this.delivery.filter(
        (m) =>
          !(m.countries?.active ?? []).some(
            (id) => id == this.selectedDeliveryCountryId
          ) &&
          (!m.supported_coutries ||
            m.supported_coutries.some(
              (code) =>
                String(code).toUpperCase() ===
                String(
                  this.countries.find(
                    (c) => c.id == this.selectedDeliveryCountryId
                  )?.code
                ).toUpperCase()
            ))
      );
    },
    deliveryLeafSections() {
      const sections = [];
      if (this.deliveryGrouping === "method") {
        const method = this.selectedDeliveryMethod;
        if (!method?.active) {
          return sections;
        }
        for (const countryId of method.countries?.active ?? []) {
          const country = this.countries.find((c) => c.id == countryId) ?? {
            id: countryId,
          };
          sections.push(
            this.buildDeliverySection(
              method,
              country,
              country.name ?? "#" + country.id
            )
          );
        }
      } else {
        if (!this.selectedDeliveryCountryId) {
          return sections;
        }
        const country = this.countries.find(
          (c) => c.id == this.selectedDeliveryCountryId
        ) ?? { id: this.selectedDeliveryCountryId };
        for (const method of this.selectedDeliveryCountryMethods) {
          sections.push(
            this.buildDeliverySection(method, country, method.name)
          );
        }
      }
      return sections;
    },
    paymentGroups() {
      const groups = [];
      for (const method of this.payments) {
        if (!(method.active || globalPaymentTypes.includes(method.type))) {
          continue;
        }
        const group = {
          key: "payment_" + method.id,
          label: method.name,
          methodId: method.id,
          items: [],
        };
        for (const row of this.paymentPrices) {
          if (row.payment_method_id == method.id) {
            group.items.push(row);
          }
        }
        groups.push(group);
      }
      return groups;
    },
  },
  mounted() {
    this.load();
    this.setRowValues("currency_code", this.enabledCurrencies, true);
    this.setRowValues("country_id", this.countries, true);
    this.setRowValues("warehouse_id", this.warehouses);
  },
  watch: {
    selectedWebshop() {
      this.calcDelivery();
      this.calcPayments();
      this.loadPrices();
      this.deliveryAdder = null;
      this.selectedDeliveryWebshop = null;
      this.selectedReturnWebshop = null;
      this.selectedDeliveryMethodId = this.deliveryMethodTabs[0]?.id ?? null;
      this.selectedDeliveryCountryId = this.deliveryCountryTabs[0]?.id ?? null;
    },
    deliveryGrouping() {
      this.deliveryAdder = null;
    },
    deliveryMethodToAdd(id) {
      if (!id) {
        return;
      }
      this.deliveryMethodToAdd = null;
      this.deliveryAdder = null;
      this.enableDeliveryMethod(id);
    },
    deliveryCountryToAdd(id) {
      if (!id) {
        return;
      }
      this.deliveryCountryToAdd = null;
      this.deliveryAdder = null;
      this.addDeliveryCountry(id);
    },
    deliveryNewCountryToAdd(id) {
      if (!id) {
        return;
      }
      this.deliveryNewCountryToAdd = null;
      this.deliveryAdder = null;
      this.selectedDeliveryCountryId = id;
    },
    deliveryMethodForCountryToAdd(id) {
      if (!id) {
        return;
      }
      this.deliveryMethodForCountryToAdd = null;
      this.deliveryAdder = null;
      this.addDeliveryMethodToCountry(id);
    },
    currencies(values) {
      this.setRowValues("currency_code", values, true);
    },
    countries(values) {
      this.setRowValues("country_id", values, true);
    },
    warehouses(values) {
      this.setRowValues("warehouse_id", values);
    },
  },
  methods: {
    buildDeliverySection(method, country, label) {
      return {
        key: "c" + country.id + "m" + method.id,
        methodId: method.id,
        countryId: country.id,
        methodType: method.type,
        label,
        isAutomaticSelect: !!method.is_automatic_select,
        canAutoSelect: !method.is_automatic_select && method.type == 1,
        typeName: deliveryTypeValues[method.type]?.name ?? null,
        logo: this.methodLogoUrl(method.icon),
        items: this.deliveryPrices.filter(
          (row) =>
            row.delivery_method_id == method.id && row.country_id == country.id
        ),
      };
    },
    sectionRows(section) {
      const showPickup = section.methodType === 2;
      const showWarehouse = this.hasMultipleActiveWarehouses;
      return this.deliveryPriceRows.map((row) => {
        if (row.key === "delivery_point_type") {
          return { ...row, show: showPickup };
        }
        if (row.key === "warehouse_id") {
          return { ...row, show: showWarehouse };
        }
        return row;
      });
    },
    paymentPriceRowsView() {
      const showWarehouse = this.hasMultipleActiveWarehouses;
      return this.paymentPriceRows.map((row) =>
        row.key === "warehouse_id" ? { ...row, show: showWarehouse } : row
      );
    },
    sectionApps(section) {
      const apps = this.deliveryApps[section.methodId];
      return Array.isArray(apps) ? apps : [];
    },
    sectionAppId(section) {
      if (section.items.length > 0) {
        return section.items[0].app_id ?? null;
      }
      const method = this.delivery.find((m) => m.id == section.methodId);
      return method?.app_id ?? null;
    },
    setSectionProvider(section, appId) {
      for (const row of section.items) {
        row.app_id = appId;
        if (row.price_id > 0) {
          http.fetch(
            "/deliveries/methods/" + row.price_id,
            { app_id: appId },
            true,
            "PUT"
          );
        }
      }
    },
    sectionAutoSelect(section) {
      return section.items.some((row) => !!row.auto_select);
    },
    toggleSectionAutoSelect(section) {
      const enable = !this.sectionAutoSelect(section);
      const endpoint = enable ? "enable-auto-select" : "disable-auto-select";
      http
        .fetch(
          "/couriers/" + endpoint,
          {
            delivery_method_id: section.methodId,
            country_id: section.countryId,
          },
          true
        )
        .then(() => {
          for (const row of section.items) {
            row.auto_select = enable ? 1 : 0;
          }
        });
    },
    methodLogoUrl(icon) {
      if (!icon) {
        return null;
      }
      if (icon.indexOf("http") !== 0 && icon.indexOf("//") !== 0) {
        return tenant.getAppFilesUrl() + "/" + icon;
      }
      return icon;
    },
    ordinal_suffix_of(i, asText = true) {
      if (asText && i < 10) {
        return this.columnNumbers[i];
      }
      i++;
      if (this.$i18n.locale !== "en") {
        return i + ".";
      }
      let j = i % 10,
        k = i % 100;
      if (j === 1 && k !== 11) {
        return i + "st";
      }
      if (j === 2 && k !== 12) {
        return i + "nd";
      }
      if (j === 3 && k !== 13) {
        return i + "rd";
      }
      return i + "th";
    },
    calcDelivery() {
      let rows = this.deliveries;
      let rowRefs = [];
      for (const key in rows) {
        rowRefs[rows[key].id] = rows[key];
        rowRefs[rows[key].id].active = false;
        rowRefs[rows[key].id].countries = {
          active: [],
          all: rowRefs[rows[key].id].supported_coutries,
        };
      }

      if (this.selectedWebshop?.id > 0) {
        for (const method of this.selectedWebshop.deliveryMethods ?? []) {
          if (rowRefs[method.id]) {
            rowRefs[method.id].active = true;
            if (method.countries !== null) {
              for (const country of method.countries) {
                rowRefs[method.id].countries.active.push(country);
              }
            }
          }
        }
      }
      this.delivery = rows;
    },
    calcPayments() {
      let rows = this.payments;
      let rowRefs = [];
      for (const key in rows) {
        rowRefs[rows[key].id] = rows[key];
        rowRefs[rows[key].id].active = false;
      }

      if (this.selectedWebshop?.id > 0) {
        for (const method of this.selectedWebshop.paymentMethods ?? []) {
          if (rowRefs[method.id]) {
            rowRefs[method.id].active = true;
          }
        }
      }
      this.payment = rows;
    },
    setRowValues(key, values, both = false) {
      const deliveryRow = this.deliveryPriceRows.find((r) => r.key === key);
      if (deliveryRow) {
        deliveryRow.values = values;
      }
      if (both) {
        const paymentRow = this.paymentPriceRows.find((r) => r.key === key);
        if (paymentRow) {
          paymentRow.values = values;
        }
      }
    },
    loadPrices() {
      if (!this.selectedWebshop?.id) {
        this.deliveryPrices = [];
        this.paymentPrices = [];
        return;
      }
      http
        .fetch("/webshops/" + this.selectedWebshop.id + "/prices")
        .then((data) => {
          this.deliveryPrices = data.delivery_prices;
          this.paymentPrices = data.payment_prices;
          this.key++;
        });
    },
    deliveryRowComplete(row) {
      return (
        row.delivery_method_id > 0 &&
        row.country_id &&
        row.currency_code &&
        row.price !== undefined &&
        row.price !== ""
      );
    },
    createChannelDeliveryPrice(row) {
      const data = {
        delivery_method_id: row.delivery_method_id,
        country_id: row.country_id,
        currency_code: row.currency_code,
        price: row.price,
        min_order_amount: row.min_order_amount ?? null,
        min_order_count: row.min_order_count ?? null,
        warehouse_id: row.warehouse_id ?? null,
        delivery_point_type: row.delivery_point_type ?? null,
        is_delivery: row.is_delivery ?? null,
        is_return: row.is_return ?? null,
        app_id: row.app_id ?? null,
        webshop_id: this.selectedWebshop.id,
      };
      this.disabled = true;
      http
        .fetch(
          "/deliveries/methods",
          data,
          true,
          "POST",
          "Creating new price.."
        )
        .then((res) => {
          this.disabled = false;
          row.price_id = res.id;
          row.has_delivery = res.has_delivery;
          row.has_return = res.has_return;
          row.is_change = res.is_change;
          row.is_home_delivery = res.is_home_delivery;
          this.key++;
        });
    },
    updateDeliveryPrice(row, key, val) {
      if (key === "delivery_method_id") {
        row["type"] = this.deliveries.find((e) => e.id === val)?.type;
      }

      if (row.price_id > 0) {
        const send = {};
        send[key] = val;
        http.fetch("/deliveries/methods/" + row.price_id, send, true, "PUT");
        return;
      }
      if (this.deliveryRowComplete(row)) {
        this.createChannelDeliveryPrice(row);
      }
    },
    addDeliveryPrice(section, key, val) {
      if (val === undefined || val === "") {
        return;
      }
      let row = this.deliveryPrices.find(
        (r) =>
          r.price_id === 0 &&
          r.delivery_method_id == section.methodId &&
          r.country_id == section.countryId
      );
      if (!row) {
        row = {
          price_id: 0,
          delivery_method_id: section.methodId,
          country_id: section.countryId,
          currency_code: this.selectedWebshop?.currency_code,
        };
        const method = this.deliveries.find((e) => e.id == section.methodId);
        if (method) {
          row.is_delivery = method.is_delivery;
          row.is_return = method.is_return;
          row.type = method.type;
        }
        this.deliveryPrices.push(row);
      }
      row[key] = val;
      if (this.deliveryRowComplete(row)) {
        this.createChannelDeliveryPrice(row);
      }
    },
    deleteDeliveryPrice(row) {
      if (!row.price_id) {
        return;
      }
      this.deleteItem = row;
      this.deleteType = "delivery";
      this.$refs.deleteModal.showModal();
    },
    paymentRowComplete(row) {
      return (
        row.country_id &&
        row.currency_code &&
        row.price !== undefined &&
        row.price !== ""
      );
    },
    createChannelPaymentPrice(row) {
      const data = {
        payment_method_id: row.payment_method_id,
        country_id: row.country_id,
        currency_code: row.currency_code,
        price: row.price,
        min_order_amount: row.min_order_amount ?? null,
        min_order_count: row.min_order_count ?? null,
        webshop_id: this.selectedWebshop.id,
      };
      http.fetch("/payments/methods", data, true, "POST").then((res) => {
        row.price_id = res.id;
        this.key++;
      });
    },
    updatePaymentPrice(row, key, val) {
      if (row.price_id > 0) {
        const send = {};
        send[key] = val;
        http.fetch("/payments/methods/" + row.price_id, send, true, "PUT");
        return;
      }
      if (this.paymentRowComplete(row)) {
        this.createChannelPaymentPrice(row);
      }
    },
    addPaymentPrice(group, key, val) {
      if (val === undefined || val === "") {
        return;
      }
      let row = this.paymentPrices.find(
        (r) => r.price_id === 0 && r.payment_method_id === group.methodId
      );
      if (!row) {
        row = {
          price_id: 0,
          payment_method_id: group.methodId,
          currency_code: this.selectedWebshop?.currency_code,
        };
        this.paymentPrices.push(row);
      }
      row[key] = val;
      if (this.paymentRowComplete(row)) {
        this.createChannelPaymentPrice(row);
      }
    },
    deletePaymentPrice(row) {
      if (!row.price_id) {
        return;
      }
      this.deleteItem = row;
      this.deleteType = "payment";
      this.$refs.deleteModal.showModal();
    },
    deletePrice() {
      const endpoint =
        this.deleteType === "delivery"
          ? "/deliveries/methods/"
          : "/payments/methods/";
      http
        .fetch(endpoint + this.deleteItem.price_id, {}, true, "DELETE")
        .then(() => {
          const list =
            this.deleteType === "delivery"
              ? this.deliveryPrices
              : this.paymentPrices;
          const index = list.indexOf(this.deleteItem);
          if (index > -1) {
            list.splice(index, 1);
          }
          this.deleteItem = null;
          this.key++;
        });
    },
    load() {
      Promise.all([
        http.fetch("/webshops?hide-global-payments=1"),
        http.fetch("/deliveries/methods/"),
        http.fetch("/payments/methods/"),
      ]).then(([webshops, deliveries, payments]) => {
        this.webshops = webshops;
        this.deliveries = deliveries;
        this.payments = payments;
        if (this.webshops.length > 0) {
          this.selectedWebshop = this.webshops[0];
        } else {
          this.selectedWebshop = {};
        }
      });
      http.fetch("/companies").then((data) => {
        this.companies = data;
      });
      http.fetch("/deliveries/apps").then((data) => {
        this.deliveryApps = data;
      });
    },
    saveBasic() {
      if (this.basicSaving) {
        return;
      }
      let data = Object.assign({}, this.selectedWebshop);
      delete data.paymentMethods;
      delete data.deliveryMethods;
      delete data.country;
      delete data.deliveryWarehouses;
      delete data.returnWarehouses;
      data.is_return = data.is_return ? 1 : 0;
      data.is_change = data.is_change ? 1 : 0;
      data.is_international_cod = data.is_international_cod ? 1 : 0;
      data.is_group_delivery_methods = data.is_group_delivery_methods ? 1 : 0;
      data.use_default_language = data.use_default_language ? 1 : 0;

      this.basicSaving = true;
      if (this.selectedWebshop.id) {
        http
          .fetch("/webshops/" + this.selectedWebshop.id, data, true, "PUT")
          .then(() => {
            this.basicSaving = false;
          })
          .catch(() => {
            this.basicSaving = false;
          });
      } else {
        http
          .fetch("/webshops", data, true)
          .then((created) => {
            this.basicSaving = false;
            if (!created?.id) {
              return;
            }
            Object.assign(created, {
              deliveryMethods: [],
              paymentMethods: [],
              deliveryWarehouses: [],
              returnWarehouses: [],
              country: null,
            });
            this.webshops.push(created);
            this.selectedWebshop = created;
          })
          .catch(() => {
            this.basicSaving = false;
          });
      }
    },
    saveDeliveryPivots() {
      if (!this.selectedWebshop?.id) {
        return;
      }
      if (this.deliverySaving) {
        this.deliverySaveQueued = true;
        return;
      }
      const data = {
        deliveries: [],
      };
      for (const method of this.delivery) {
        if (method.active) {
          data.deliveries.push({
            id: method.id,
            countries: method.countries?.active ?? [],
          });
        }
      }
      this.deliverySaving = true;
      http
        .fetch(
          "/webshops/" + this.selectedWebshop.id + "/deliveries",
          data,
          true
        )
        .then(() => {
          this.deliverySaving = false;
          if (this.deliverySaveQueued) {
            this.deliverySaveQueued = false;
            this.saveDeliveryPivots();
          }
        });
    },
    enableDeliveryMethod(id) {
      const method = this.delivery.find((m) => m.id == id);
      if (!method) {
        return;
      }
      method.active = true;
      this.selectedDeliveryMethodId = method.id;
      this.saveDeliveryPivots();
    },
    disableDeliveryMethod(method) {
      method.active = false;
      if (method.id == this.selectedDeliveryMethodId) {
        this.selectedDeliveryMethodId = this.deliveryMethodTabs[0]?.id ?? null;
      }
      this.saveDeliveryPivots();
    },
    addDeliveryCountry(countryId) {
      const method = this.selectedDeliveryMethod;
      if (!method || method.countries.active.some((id) => id == countryId)) {
        return;
      }
      method.countries.active.push(countryId);
      this.saveDeliveryPivots();
    },
    removeDeliveryCountry(method, countryId) {
      const index = method.countries.active.findIndex((id) => id == countryId);
      if (index === -1) {
        return;
      }
      method.countries.active.splice(index, 1);
      this.saveDeliveryPivots();
    },
    disableDeliveryCountry(countryId) {
      for (const method of this.delivery) {
        if (!method.active) {
          continue;
        }
        const index = method.countries.active.findIndex(
          (id) => id == countryId
        );
        if (index > -1) {
          method.countries.active.splice(index, 1);
        }
      }
      if (this.selectedDeliveryCountryId == countryId) {
        this.selectedDeliveryCountryId =
          this.deliveryCountryTabs[0]?.id ?? null;
      }
      this.saveDeliveryPivots();
    },
    addDeliveryMethodToCountry(methodId) {
      const method = this.delivery.find((m) => m.id == methodId);
      if (!method) {
        return;
      }
      if (!method.active) {
        method.active = true;
      }
      if (
        !method.countries.active.some(
          (id) => id == this.selectedDeliveryCountryId
        )
      ) {
        method.countries.active.push(this.selectedDeliveryCountryId);
      }
      this.saveDeliveryPivots();
    },
    savePayment() {
      let data = {
        payments: [],
      };

      for (const payment of this.payment) {
        if (payment.active) {
          data.payments.push({
            id: payment.id,
          });
        }
      }

      http.fetch(
        "/webshops/" + this.selectedWebshop.id + "/payments",
        data,
        true
      );
    },
    saveWarehouses() {
      let data = {
        delivery: [],
        return: [],
      };

      for (const warehouse of this.selectedWebshop.deliveryWarehouses) {
        data.delivery.push(warehouse.id);
      }
      for (const warehouse of this.selectedWebshop.returnWarehouses) {
        data.return.push(warehouse.id);
      }

      http.fetch(
        "/webshops/" + this.selectedWebshop.id + "/warehouses",
        data,
        true
      );
    },
    addWarehouse(type) {
      let e = null;
      let webshop = null;
      if (type === "delivery") {
        e = this.selectedWebshop.deliveryWarehouses;
        webshop = this.selectedDeliveryWebshop;
      } else if (type === "return") {
        e = this.selectedWebshop.returnWarehouses;
        webshop = this.selectedReturnWebshop;
      }
      if (!e || !webshop) {
        return;
      }
      if (e.some((w) => w.id == webshop.id)) {
        return;
      }
      e.push({ id: webshop.id, name: webshop.name });
      if (type === "delivery") {
        this.selectedDeliveryWebshop = null;
      } else {
        this.selectedReturnWebshop = null;
      }
    },
    deleteWarehouse(type, id) {
      let e = null;
      if (type === "delivery") {
        e = this.selectedWebshop.deliveryWarehouses;
      } else if (type === "return") {
        e = this.selectedWebshop.returnWarehouses;
      }
      if (!e) {
        return;
      }
      const index = e.findIndex((i) => i.id == id);
      if (index === -1) {
        return;
      }
      e.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.delivery-add-select {
  display: inline-block;
  width: 240px;
  vertical-align: middle;
}
.section-provider-select {
  display: inline-block;
  width: 200px;
  vertical-align: middle;
}
.auto-select-check {
  height: 28px;
  padding-left: 30px;
}
.removable-badge,
.tab-removable {
  position: relative;
}
.removable-badge {
  cursor: default;
}
.removable-badge .remove-x,
.tab-removable .remove-x {
  display: none;
  position: absolute;
  top: -4px;
  right: -4px;
  z-index: 2;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  color: var(--gray-dark, #343a40);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.35);
  cursor: pointer;
  align-items: center;
  justify-content: center;
}
.removable-badge:hover .remove-x,
.tab-removable:hover .remove-x {
  display: inline-flex;
}
.removable-badge .remove-x:deep(svg),
.tab-removable .remove-x:deep(svg) {
  width: 12px;
  height: 12px;
}
.removable-badge .remove-x:hover,
.tab-removable .remove-x:hover {
  color: #af0f0f;
}
.btn-main-method-list {
  padding: 0.4em 0.3em;
  font-size: 0.8em;
  max-width: 7em;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 4em;
}
</style>
